import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Text,
  IconButton,
  Spacer,
  HStack,
} from '@chakra-ui/react';
import { CloseCircleOutline, formatNumber, useToast } from '@aslanpay/portal-common-lib';
import { useManagingCompanyStore } from 'app/store';

import TransferPointsForm from './TransferPointsForm/TransferPointsForm';
import { TransferPointsModalProps } from './TransferPointsModal.types';
import { TransferPotInfo } from './TransferPointsForm/TransferPointsForm.types';

function TransferPointsModal({ isOpen, onClose, originPot }: TransferPointsModalProps) {
  const company = useManagingCompanyStore((state) => state.company);

  const toast = useToast();

  const companyId = company?.id || '';

  const onSuccess = ({ fromPotName, toPotName, points }: TransferPotInfo) => {
    toast({
      position: 'top-right',
      title: `${formatNumber(points)} points have been transferred to ${toPotName}`,
      description: `Both ${fromPotName} and ${toPotName} pots have been updated.`,
      status: 'success',
    });

    onClose();
  };

  const onError = ({ fromPotName, toPotName }: TransferPotInfo) => {
    toast({
      position: 'top-right',
      title: 'Failed to transfer points',
      description: `Could not transfer points from ${fromPotName} to ${toPotName}.`,
      status: 'error',
    });
  };

  if (!originPot) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="592px" w="592px">
        <ModalHeader pb={4}>
          <HStack align="flex-start">
            <Text as="h4" fontStyle="h4Bold" color="brand.black">
              Transfer points from {originPot.name}
            </Text>

            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close transfer points modal"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody pb={6}>
          <TransferPointsForm
            onClose={onClose}
            onError={onError}
            onSuccess={onSuccess}
            companyId={companyId}
            originPot={originPot}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default TransferPointsModal;
